"use client";

import { Navbar as AfaNavbar } from "@afa-shared/afa-components";
import clsx from "clsx";

import useMediaQueryWrapper from "hooks/useMediaQuery";
import useParamToggler from "hooks/useParamToggler";
import { useMobileNavigationOpenState } from "hooks/zustand/useMobileNavigationOpenState";

import navigationStyles from "../../navigation/navigation.module.css";

interface NavbarProps {
  menu: React.ReactNode;
  columnTwo?: React.ReactNode;
}

/**
 * A wrapper around the AfaNavbar component to be used in client components.
 * @param props - Props to be passed to the AfaNavbar component.
 * @returns The AfaNavbar component with the passed props.
 */

export default function Navbar({ menu, columnTwo }: NavbarProps) {
  const { isOpen } = useParamToggler();
  const navigationIsOpen = useMobileNavigationOpenState((state) => state.mobileNavigationIsOpen);
  const isTablet = useMediaQueryWrapper("tablet");
  return (
    <AfaNavbar
      menu={menu}
      columnTwo={columnTwo}
      useMobileMenu={isTablet}
      className={clsx({ [navigationStyles.open]: navigationIsOpen && isOpen })}
    />
  );
}
